import moment from 'moment'

class Dates {

  constructor(dateToParse, locale) {
    moment.locale(locale);
    this.monthsShort = moment.monthsShort();
    this.months = moment.months();
    this.days   = moment.weekdays();
    this.toParse = dateToParse;
  }

  parseDateLive() {
    const SPACE = ' ';
    let pdate  = moment(this.toParse, 'DD/MM/YYYY HH:mm:ss');
    let day    = pdate.date();
    let month  = this.monthsShort[pdate.month()];
    let minute = pdate.minute();
    let hhMM   = pdate.hour();

    if ( minute == 0 ) {
      hhMM += ':00';
    } else {
      hhMM += ':' + minute;
    }

    return day + SPACE +  month + SPACE + hhMM + SPACE +'hs.';
  }

  parseDateLiveBig() {
    let pdate  = moment(this.toParse, 'DD/MM/YYYY HH:mm:ss');
    return pdate.isValid() ? this.toCase(`${pdate.format('LLLL')} hrs.`) : '';
  }

  toCase(str)
  {
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }

}
export const parseDate = ({ date }) =>
  moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

export const parseDateNew = date =>
  moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

export default Dates;
